import * as React from "react";
const SvgFiRrSquareCode = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-code_svg__a)">
      <path
        fill="#062147"
        d="M14.831 17a.999.999 0 0 1-.707-1.707l2.583-2.583a1 1 0 0 0 0-1.415l-2.583-2.584a.999.999 0 1 1 1.414-1.414l2.583 2.583c.566.566.879 1.32.879 2.121s-.312 1.555-.879 2.122l-2.583 2.583a1 1 0 0 1-.707.294m-4.955-.298a1 1 0 0 0 0-1.414l-2.583-2.583A1 1 0 0 1 7 11.997c0-.268.104-.518.293-.707l2.583-2.583a.999.999 0 1 0-1.414-1.414L5.879 9.876A2.98 2.98 0 0 0 5 11.998c0 .802.312 1.555.879 2.122l2.583 2.583a.997.997 0 0 0 1.414-.001M24 19V5c0-2.757-2.243-5-5-5H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5M19 2c1.654 0 3 1.346 3 3v14c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-code_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareCode;
